import './style.scss'

import { axios as $http } from 'cm'
import { getEnvHost } from 'src/frontend-lib/tools/getPlatform'
import Bridge from 'src/frontend-lib/lib/Bridge'
let myBridge = new Bridge()
let IS_APP = window.$platform.isYixinliApp
let staticHost = window.location.protocol + getEnvHost(`//static.xinli001.com`)
let qaapiHost = window.location.protocol + getEnvHost(`//qaapi.xinli001.com`)

export default class clockCardToast {
  constructor(token) {
    this.token = token
    if (this.todayIsShow()) {
      this.render()
    }
  }

  todayIsShow() {
    let clockCardToast = localStorage.clockCardToast
    if (!clockCardToast) {
      clockCardToast = { lastTime: null }
    } else {
      clockCardToast = JSON.parse(clockCardToast)
    }

    if (clockCardToast.lastTime !== this.getParseTime()) {
      return true
    }
  }

  render() {
    $http.get(`${qaapiHost}/user-info?token=${this.token}`).then(res => {
      let _res = res.data,
        _data = _res.data
      if (_res.code === 0 && _data.today_clock) {
        let $el = document.createElement('div')
        $el.setAttribute('class', 'clockCardToast')
        $el.innerHTML = `
            <div class="clockCardToast">
              <div class="wrap">
                <div class="content">
                  <p class="title">社群提醒</p>
                  <p class="desc">今日星标回答打卡成功！</p>
                  <div class="btn">查看我的打卡进度</div>
                </div>
                <div class="closeBtn yxlicon icon-guanbi"></div>
              </div>
            </div>
          `
        document.querySelector('body').appendChild($el)
        this.bindEvent()
      }
    })
  }

  bindEvent() {
    localStorage.clockCardToast = JSON.stringify({
      lastTime: this.getParseTime()
    })

    $(document).delegate('.clockCardToast .btn', 'click', function() {
      let href = staticHost + '/msite/index.html#/qaClockCard'
      if (IS_APP) {
        myBridge.call('openWebView', {
          url: href,
          isCurrentPageOpen: 0
        })
      } else {
        window.location.href = href
      }
    })
    $(document).delegate('.clockCardToast .closeBtn', 'click', function() {
      $('.clockCardToast').hide()
    })
  }

  getParseTime() {
    let date = new Date()
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('')
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/components/clockCardToast/index.js